module.exports = __webpack_public_path__ + "media/src/site/images/slider-63b5b47481d90ba458b9514f22f89fc1.gif";